import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/home';
import PisoVinilicoLvtPage from './pages/piso-vinilico-lvt-page';
//import PisosSpcPage from './pages/pisos-spc-page'; 
import PisosSpcPagePremium from './pages/pisos-spc-premium';
import PisoDeCauchoPage from './pages/piso-de-caucho-page';
import PisoDePvcRigido from './pages/piso-de-pvc-rigido';
import PisoDeckSinteticoPage from './pages/piso-deck-sintetico-page';
import MuroLambrinConcavo from './pages/muro-lambrin-concavo';
import MuroCarbonDeBambu from './pages/muro-carbon-de-bambu';
import MuroBambooEspejo from './pages/muro-bamboo-espejo';
import MuroPlacaTipoMarmolPage from './pages/muro-placa-tipo-marmol-page';
import MuroLambrinSinteticoPage from './pages/muro-lambrin-sintetico-page';
import DeckTablonWpc from './pages/deck-tablon-wpc';
import TechoPlafonFalsoPage from './pages/techo-plafon-falso-page';
import ViguetaWpcPage from './pages/vigueta-wpc-page';
import EscritoriosEscolares from './pages/escritorios-escolares';
import RecubrimientosMuros from './pages/recubrimientos-muros';
import RecubrimientosPisos from './pages/recubrimientos-pisos';
import ContactoDecototal from './pages/contacto-decototal';
import CalculadoraMaterialesPage from './pages/calculadora-materiales-page';
import Gracias from './pages/gracias';
import FollajeArtificial from './pages/follaje-artificial';
// Importa los componentes de botones flotantes
import BotonWhatsapp from "./components/otros/BotonWhatsapp";
import BtnScrollToTop from './components/otros/BtnScrollToTop'; // btn flotante regresar al top 

// Importa los archivos CSS globales
import './assets/css/custom.css';
import './assets/css/plugins.css';
import './assets/css/styles.css';
import './assets/css/styles.css.map'; // Este puede no ser necesario en producción.
import './assets/css/styles.scss';

// Importa los CSS de la carpeta "plugins"
import './assets/css/plugins/animate.css';
import './assets/css/plugins/animated-headline.css';
import './assets/css/plugins/bootstrap.min.css';
import './assets/css/plugins/default.css';
import './assets/css/plugins/et-line.css';
import './assets/css/plugins/fontawesome-all.min.css';
import './assets/css/plugins/lightgallery.css';
import './assets/css/plugins/magnific-popup.css';
import './assets/css/plugins/nav-menu.css';
import './assets/css/plugins/odometer-theme-default.css';
import './assets/css/plugins/prism.css';
import './assets/css/plugins/themify-icons.css';


function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

function AppRoutes() {
  const location = useLocation();
  const hideWhatsapp = location.pathname === '/recubrimientos-muros';

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/piso-vinilico-lvt-page" element={<PisoVinilicoLvtPage />} />
        {/* <Route path="/pisos-spc-page" element={<PisosSpcPage />} />   */}
        <Route path="/pisos-spc-premium" element={<PisosSpcPagePremium />} />
        <Route path="/piso-de-caucho-page" element={<PisoDeCauchoPage />} />
        <Route path="/piso-de-pvc-rigido" element={<PisoDePvcRigido />} />
        <Route path="/piso-deck-sintetico-page" element={<PisoDeckSinteticoPage />} />
        <Route path="/muro-lambrin-concavo" element={<MuroLambrinConcavo />} />
        <Route path="/muro-carbon-de-bambu" element={<MuroCarbonDeBambu />} />
        <Route path="/muro-bamboo-espejo" element={<MuroBambooEspejo />} />
        <Route path="/muro-placa-tipo-marmol-page" element={<MuroPlacaTipoMarmolPage />} />
        <Route path="/muro-lambrin-sintetico-page" element={<MuroLambrinSinteticoPage />} />
        <Route path="/deck-tablon-wpc" element={<DeckTablonWpc />} />
        <Route path="/techo-plafon-falso-page" element={<TechoPlafonFalsoPage />} />
        <Route path="/vigueta-wpc-page" element={<ViguetaWpcPage />} />
        <Route path="/escritorios-escolares" element={<EscritoriosEscolares />} />
        <Route path="/recubrimientos-muros" element={<RecubrimientosMuros />} />
        <Route path="/recubrimientos-pisos" element={<RecubrimientosPisos />} />
        <Route path="/contacto-decototal" element={<ContactoDecototal />} />
        <Route path="/calculadora-materiales" element={<CalculadoraMaterialesPage />} />
        <Route path="/gracias/:producto" element={<Gracias />} />
        <Route path="/follaje-artificial" element={<FollajeArtificial />} />
      </Routes>
      {/* Botones flotantes */}
      {!hideWhatsapp && <BotonWhatsapp />}{/* Ocultar WhatsApp en la página de muros */}
      <BtnScrollToTop /> {/* botón flotante que lleva al top de la página */}
    </>
  );
}

export default App;

